/**
 * When a frame that threw is drawn again by itself (`ErrorBoundary`'s `recover`).
 *
 * QA dev 30.10.2026 (С1-9, thread 3ad14d62, `shots/A-С1-9-empty.jpg`): the chat's boundary caught
 * «NotFoundError: Failed to execute 'removeChild' on 'Node'» after the ninth answer and drew NOTHING in its
 * place — the whole feed gone, the input alone on the screen, until F5 brought it back intact. A failed DOM
 * reconciliation is not the thread's data: a fresh mount of the same subtree is what F5 did. So the frame is
 * mounted afresh at once, a few times; a frame that keeps throwing is a real fault and stays down, with a
 * button to try again — never a loop.
 */

/** Fresh mounts allowed within `WINDOW_MS` before the frame stays down. */
export const MAX_RETRIES = 3;
export const WINDOW_MS = 10_000;

/** → whether a frame that threw at *nowMs* is mounted afresh, given the times of its earlier fresh mounts. */
export function shouldRetry(retries: readonly number[], nowMs: number): boolean {
  return retries.filter((at) => nowMs - at < WINDOW_MS).length < MAX_RETRIES;
}
